import styled from 'styled-components';
import { Button } from '@/ui';

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const StyledButton = styled(Button)`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
